// Utils
import http from '../../../../utils/services/http';
import delay from '../../../../../common/utils/lib/delay';

// Constants
import { METHODS } from '../../../../../common/utils/http/httpConstants';

const MAX_POLLING_ATTEMPTS = 10;

enum AppleCheckoutResponseStatus {
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
}

type CheckoutSessionStatusResponse = {
    status: AppleCheckoutResponseStatus;
    checkoutSessionId: string;
};

export const createAppleCheckoutSession = async () => {
    const response = await http({
        method: METHODS.POST,
        url: 'payments/apple/checkout/create-session',
    });

    return response.data.sessionId;
};

export const pollCheckoutSessionStatus = async (checkoutSessionId: string): Promise<CheckoutSessionStatusResponse> => {
    for (let i = 0; i < MAX_POLLING_ATTEMPTS; i++) {
        const response = await http({
            method: METHODS.GET,
            url: `/payments/checkout/sessions/${checkoutSessionId}`,
        });

        if (response.data.session?.status === AppleCheckoutResponseStatus.SUCCESS) {
            return { status: AppleCheckoutResponseStatus.SUCCESS, checkoutSessionId };
        } else if (response.data.session?.status === AppleCheckoutResponseStatus.PENDING) {
            // Wait for 2 seconds before attempting it again
            await delay(2000);
        } else if (response.data.session?.status === AppleCheckoutResponseStatus.ERROR) {
            return { status: AppleCheckoutResponseStatus.ERROR, checkoutSessionId };
        }
    }

    return { status: AppleCheckoutResponseStatus.PENDING, checkoutSessionId };
};
